<template>
  <div class="content" ref="content">
    <el-button class="goBack" @click="goBack">返回</el-button>
    <iframe v-show="iframeShow" id="show-iframe"  frameborder=0 name="showHere" scrolling=auto :src="iframeSrc" ref="iframe"></iframe>
    <div class="dlSelect" v-show="!setMonitorShow">监控维度：</div>
    <div class="dlSelectProjectCon" v-show="!setMonitorShow">
      <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
      <el-select
        @change="dimensionChange"
        v-model="search.dimension"
        placeholder="请选择维度"
      >
        <el-option
          v-for="item in dimensionList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="outBack" v-show="outBackShow" @click="outBack">退出回放</div>
    <!-- <iframe id="dialogFrame" :src="srcV" frameborder="0" scrolling="no" style=" position: fixed; z-index: 1; width: 100%; height: 100%; top: 0;left:0;"></iframe> -->
    <div class="contorlContent" v-if="false">
      <div class="itemContorl" @click="setCanvasF(1)">
        <div class="type type_1"></div>
        <span class="text">原始比例</span>
        <div class="line"></div>
      </div>
      <div class="itemContorl" @click="setCanvasF(2)">
        <div class="type type_2"></div>
        <span class="text">放大</span>
        <div class="line"></div>
      </div>
      <div class="itemContorl" @click="setCanvasF(3)">
        <div class="type type_3"></div>
        <span class="text">缩小</span>
        <div class="line"></div>
      </div>
      <div class="itemContorl" @click="setCanvasF(4)">
        <div class="type type_4"></div>
        <span class="text">{{ leftOutText }}</span>
      </div>
    </div>
    <div class="setCarInfo" ref="setCarInfo" v-show="carSetShow">
      <div class="setCarTitle">{{ fabricClickName }}</div>
      <div class="setCarBtnL">启动</div>
      <div class="setCarBtnR">紧停</div>
    </div>
    <canvas id="myCanvas" :width="canvasW" :height="canvasH" :class="[!setMonitorShow?'':'topOut']"></canvas>
    <!-- <canvas id="midCanvas"  :width="canvasW" :height="canvasH"></canvas>
    <canvas id="dhCanvas" :width="canvasW" :height="canvasH"></canvas> -->

    <!-- <div class="warnNumContent" ref="warnNumContent" @click="warnShow">
      <div class="warnNum">{{ warnNum }}</div>
      <div class="warnText">报警</div>
    </div> -->
    <!-- <div class="warnContent" ref="warnContent">
      <div class="warnItemTop" v-for="item in topWarnList" :key="item.index">
        <div class="itemTop" v-for="i in item.list" :key="i.index">
          <div class="itemType">{{ i.cnName }}</div>
          <div class="itemEquipName">{{ item.equipName }}</div>
          <div class="setStop">紧停</div>
        </div>
        <div
          style="width: 100%; height: 1px; background: #e1e1e1; margin-top: 5px"
        ></div>
      </div>
      <div class="warnItem" v-for="item in warnList" :key="item.index">
        <div class="itemTitle">
          <span class="bgLine"></span>
          <span class="itemTitleText">{{ item.equipName }}</span>
        </div>
        <div class="itemContent">
          <div class="itemShow" v-for="i in item.list" :key="i.index">
            <span class="redPointer"></span>{{ i.cnName }}
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div> -->
    <div class="setMonitor" :class="leftOut == true ? 'leftOut' : ''" v-show="setMonitorShow">
      <div class="title_1">
        <div class="iconShow"></div>
        <div class="titleText">作业回放</div>
      </div>
      <div class="setMonitorItem">
        <div class="itemText">请选择工程与作业：</div>
        <div class="projectCon">
          <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
          <el-select
            v-model="search.project"
            @change="projectChange"
            placeholder="请选择工程"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="workCon">
          <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
          <el-select
            v-model="search.work"
            @change="workChange"
            placeholder="请选择作业"
          >
            <el-option
              v-for="item in workList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="setMonitorItem" style="display: none">
        <div class="itemText">监控维度</div>
        <div class="projectCon" style="display: none">
          <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
          <el-select
            @change="parameterChange"
            v-model="parameterArr"
            multiple
            collapse-tags
            placeholder="请选择监控参数"
          >
            <el-option
              v-for="item in parameterList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="projectCon">
          <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
          <el-select
            @change="dimensionChange"
            v-model="search.dimension"
            placeholder="请选择维度"
          >
            <el-option
              v-for="item in dimensionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="clear:both"></div>
      </div>

      <div class="timeCheckItem" v-if="!REShow">
        <div class="timeCheck">时间范围选择:</div>
        <div
          class="timeCheck"
          v-for="(item, index) in timeList"
          :key="index"
          @click="setTime(item)"
        >
          起始 {{ item.startTime }} 结束 {{ item.endTime }}
        </div>
      </div>

      <div class="setMonitorItem" v-if="!REShow">
        <div class="itemText">请选择回放日期与时间：</div>

        <!-- <div class="timeCheckItem" v-if="!REShow">
          <div class="timeCheck">时间范围选择:</div>
          <div
            class="timeCheck"
            v-for="(item, index) in timeList"
            :key="index"
            @click="setTime(item)"
          >
            起始 {{ item.startTime }} 结束 {{ item.endTime }}
          </div>
        </div> -->

        <div class="projectConD">
          <!-- <el-date-picker
            v-model="value2"
            type="datetimerange"
            @change="getSTime"
            format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker> -->
          <el-date-picker
            v-model="value2"
            type="date"
            @change="getSTime"
            format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="projectConDD">
          <el-time-select
            placeholder="起始时间"
            v-model="startTimeSet"
            :picker-options="{
              start: '00:05',
              step: '00:05',
              end: '23:55'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="endTimeSet"
            :picker-options="{
              start: '08:30',
              step: '00:05',
              end: '23:55',
              minTime: startTimeSet
            }">
          </el-time-select>
        </div>
        <div style="clear:both"></div>
      </div>
      <!-- <div class="timeCheckItem" v-if="!REShow">
        <div class="timeCheck">时间范围选择:</div>
        <div
          class="timeCheck"
          v-for="(item, index) in timeList"
          :key="index"
          @click="setTime(item)"
        >
          起始 {{ item.startTime }} 结束 {{ item.endTime }}
        </div>
      </div> -->

      <div class="setMonitorItem" v-if="!REShow">
        <el-button
          style="float: right; margin-right: 16px"
          type="primary"
          @click="startRE"
          plain
          >确认</el-button
        >
      </div>
      <!-- <div class="setMonitorItem"  v-if="!REShow" style="padding-left:14px;padding-right:14px"> -->
      <!-- <c-progress class="c-progress" :percent="percentNum" @percentChange="onPercentChange" @upChange="upSetChange" :width="350" :showPerText="false" />
            <div class="nowDateTimeShow">{{nowDateTimeShow}}</div> -->
      <!-- </div> -->
    </div>

    <div class="progressContent" v-if="!REShow && cotorl">
        <div class="progressContentBG"></div>
        <!-- <span class="playState" @click="setPlayState">{{playStateText}}</span> -->
        <div class="playAndPuase_1" @click="setPlayState" v-if="playStateText == '暂停'"></div>
        <div class="playAndPuase_2" @click="setPlayState" v-if="playStateText == '播放'"></div>
        <span class="speedText">播放速度</span>
        <el-select @change="playCodeChange" v-model="playCodeName" placeholder="" class="playCodeChange">
            <el-option
            v-for="item in playSpeedList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <c-progress class="c-progress" :getPercent="getpercentNum" :percent="percentNum" @percentChange="onPercentChange" @upChange="upSetChange" :width="1872" :showPerText="false" />
        <div class="nowDateTimeShow">{{nowDateTimeShow}}</div>

    </div>

    <div
      class="infoListContent"
      v-if="REShow"
      :class="leftOut == true ? 'leftOut' : ''"
    >
      <div class="infoTab">
        <div
          class="tabItem"
          @click="tabChange('0')"
          v-bind:class="tabChangeCode == 0 ? 'tabItem_w' : ''"
        >
          作业
        </div>
        <div
          class="tabItem"
          @click="tabChange('1')"
          v-bind:class="tabChangeCode == 1 ? 'tabItem_r' : ''"
        >
          工程
        </div>
        <div
          class="tabItem"
          @click="tabChange('2')"
          v-bind:class="tabChangeCode == 2 ? 'tabItem_l' : ''"
        >
          设备
        </div>
      </div>
      <transition name="el-fade-in">
        <div class="infoListShow workProgress" v-show="tabChangeCode == 0">
          <div class="workProgress_title">
            <img class="iconImg" src="../../images/all/icon_3.png" alt="" />
            作业进度
          </div>
          <div
            class="workProgress_content"
            v-for="(item, index) in progressList"
            :key="index"
          >
            <el-row>
              <el-col :span="14"
                ><div :style="{ fontWeight: index == 0 ? 'bold' : 'normal' }">
                  {{ item.name }}进度：
                </div></el-col
              >
              <el-col :span="10">
                <div>
                  <el-progress
                    :percentage="item.percentage"
                    :stroke-width="8"
                  ></el-progress>
                  <!-- -- -->
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14"
                ><div :style="{ fontWeight: index == 0 ? 'bold' : 'normal' }">
                  已作业时长/剩余时长：
                </div></el-col
              >
              <el-col :span="10">
                <div>
                  {{item.workTime}} / {{item.remainTime}}
                  <!-- --/-- -->
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </transition>
      <transition name="el-fade-in">
        <div class="infoListShow" v-show="tabChangeCode == 1">
          <div
            class="infoItemSetMask"
            :class="{ leftToShowClass: showCode, leftToHideClass: hideCode }"
          >
            <div class="maskBack" @click="maskBack">←</div>
            <div class="setMaskTitle">{{ maskBackTitle }}</div>
            <div class="workSet">
              <WorkSet :maskBackCode="maskBackCode"></WorkSet>
            </div>
          </div>
          <el-table
            :data="workList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
          >
            <el-table-column
              prop="name"
              label="作业"
              width=""
            ></el-table-column>
            <el-table-column prop="status" label="状态" width="">
              <template slot-scope="scope">
                <span class="wordStatus_1" v-if="scope.row.status == 0"
                  >未完成</span
                >
                <span class="wordStatus_2" v-if="scope.row.status == 1"
                  >作业中</span
                >
                <span class="wordStatus_3" v-if="scope.row.status == 2"
                  >完成</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="typeName" label="进度" width="">
              <template slot-scope="scope">
                <el-progress
                  :percentage="(scope.row.process * 100).toFixed(2)"
                  :stroke-width="8"
                ></el-progress>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="" label="操作" width="">
                    <template slot-scope="scope">
                        <span class="contorClick" @click="contorFun(scope.row.id,scope.row.name)">展开</span>
                    </template>
                </el-table-column> -->
          </el-table>
        </div>
      </transition>
      <!-- <transition name="el-fade-in">
        <div class="infoListShow" v-show="tabChangeCode == 2">
          <el-table
            :data="equipmnetList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
          >
            <el-table-column
              prop="name"
              label="名称"
              width=""
            ></el-table-column>
            <el-table-column prop="status" label="状态" width="">
              <template slot-scope="scope">
                <span class="wordStatus_1" v-if="scope.row.status == 0"
                  >离线</span
                >
                <span class="wordStatus_2" v-if="scope.row.status == 1"
                  >空闲</span
                >
                <span class="wordStatus_3" v-if="scope.row.status == 2"
                  >作业中</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="" label="工序" width=""></el-table-column>
          </el-table>
        </div>
      </transition> -->
    </div>

    <div
      class="colorContent"
      ref="colorContent"
      v-if="search.dimension != 1 && search.dimension"
    >
      <div class="colorType">
        <div
          class="colorItem colorItem_1"
          :class="search.dimension == 2 ? 'colorActive' : ''"
        >
          遍数
        </div>
        <div
          class="colorItem colorItem_2"
          :class="search.dimension == 3 ? 'colorActive' : ''"
        >
          压实
        </div>
      </div>
            <RollLegend class="rollLegend" v-show="search.dimension == 2" fontColor="black" legendType="1"></RollLegend>
            <RollLegend class="rollLegend" v-show="search.dimension == 3" fontColor="wblack" legendType="2"></RollLegend>
      <!-- <div class="rollImg" v-show="search.dimension == 2"></div> -->
      <!-- <div class="icvImg" v-show="search.dimension == 3"></div> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery"
import { fabric } from "fabric";
import canvasMixRe from "../../utils/canvasMixRe";
import RollLegend from "../quality/part/rollLegend";
import { setGrid } from "../../utils/canvasSet";
import jcanvas from "jcanvas"
jcanvas($,window)
import {
  getEnginList,
  getWorks,
  getWorkEquipsList,
  getWorkInfo,
  getRoadSectionPointer,
  getWorkTimeList,
  // getWorkTrack
} from "../../utils/api";
import {
//   changeRoadPointer,
  changeUnRoadPointer,
  dateFormat,
  // timestampToTime
} from "../../utils/commons";
import {  sendWSPush } from "../../utils/websocket";
import mixinList from "../../utils/mixinList";
import WorkSet from "../../components/engineering/workSet";
import CProgress from "../../components/c-progress";
import websockMix from "../../utils/websockMixRe";
import Cookies from "js-cookie";
export default {
  name: "app",
  inject:['reload'],
  mixins: [mixinList, canvasMixRe, websockMix],
  data() {
    return {
      pickerOptions: {},
      iframeShow: false,
      iframeSrc: './reload/historyReloadCanvas.shtml',
      srcV: './exam/example/chapter3_1.html',
      carSetShow: false,
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/EngineeringCenter",
        },
        {
          name: "作业质量",
          path: "/transfer/qualityDay",
        },
        {
          name: "作业回放",
          path: "",
        },
      ],
      projectList: [],
      equipmnetList: [],
      parameterList: [
        {
          label: "压实度",
          value: "icv",
        },
        {
          label: "速度",
          value: "speed",
        },
        {
          label: "温度",
          value: "temperature",
        },
        {
          label: "剩余油量",
          value: "oilmass",
        },
        {
          label: "振动频率",
          value: "frequencyVal",
        },
        {
          label: "振动振幅",
          value: "swingVal",
        },
      ],
      dimensionList: [
        {
          label: "轨迹",
          value: "1",
        },
        {
          label: "遍数",
          value: "2",
        },
        {
          label: "压实度",
          value: "3",
        },
      ],
      workList: [],
      aShow: false,
      search: {
        project: "",
        work: "",
        dimension: "",
      },
      tabChangeCode: 0,
      canvas: "",
      midCanvas: "",
      fabricClickId: "", //canvas 点击到的车辆id
      fabricClickName: "",
      parameterArr: [
        "icv",
        "speed",
        "temperature",
        "oilmass",
        "frequencyVal",
        "swingVal",
      ],
      parameterPavArr: ["speed", "temperature", "oilmass"],
      parameterRollDArr: [
        "icv",
        "speed",
        "temperature",
        "oilmass",
        "frequencyVal",
        "swingVal",
      ],
      parameterRollSArr: [
        "icv",
        "speed",
        "temperature",
        "oilmass",
        "frequencyVal",
        "swingVal",
      ],
      parameterRollLArr: ["speed", "temperature", "oilmass"],
      setMask: 0,
      showCode: false,
      hideCode: false,
      maskBackTitle: "",
      maskBackCode: 0,
      dimension: 1,
      warnShowCode: 0,
      carWidthMap: "",
      scaleCode: "",
      REShow: true,
      cotorl: false,
      value2: "",
      type: "",
      startTime: "",
      endTime: "",
      workId: "",
      oldWorkId: '',
      allTime: "", // 时间范围时间戳
      nowDateTimeShow: "", // 回放当前时间
      percentNum: 0,
      getpercentNum: 0,
      workType: 4,
      progress: [
        {
          name: "总体",
          percentage: "--",
          workTime: "--",
          remainTime: "--",
        },
        // {
        //   name: "摊铺",
        //   percentage: "--",
        //   workTime: "06:13:09",
        //   remainTime: "01:46:51",
        // },
        // {
        //   name: "初压",
        //   percentage: "--",
        //   workTime: "06:13:09",
        //   remainTime: "01:46:51",
        // },
        // {
        //   name: "复压",
        //   percentage: "--",
        //   workTime: "02:13:09",
        //   remainTime: "05:46:51",
        // },
        // {
        //   name: "终压",
        //   percentage: "--",
        //   workTime: "02:13:09",
        //   remainTime: "05:46:51",
        // },
      ],
      progressList: [],
      timeList: [],
      perCode: 0,
      playCode: 1,
      playCodeName: "X1",
      playStateText: "播放",
      playSpeedList: [
        {
          label: "X1",
          value: "1",
        },
        {
          label: "X2",
          value: "2",
        },
        // {
        //   label: "X4",
        //   value: "3",
        // },
      ],
      leftOut: false,
      leftOutText: "清屏",
      roadType:0,
      canvasW: 0,
      canvasH: 0,
      pyYCode: 0,
      pyXCode: 0,
      toBigCode: 15,
      setMonitorShow: true,
      iframeWin: null,
      setRoadMap: '',
      setFRoadMap: '',
      projectName: '',
      workName: '',
      windowChange: 2,
      startTimeSet: '',
      endTimeSet: '',
      outBackShow: false,
      firstEnter:true,//第一次进入，且是从报警履历跳转而来
    };
  },
  computed: {},
  created() {
    // closeWs()
    // let that = this
    // setInterval(function(){
    //     that.percentNum = that.percentNum + 1
    //     console.log(that.percentNum)
    // },1000)
  },
  mounted() {
    let that = this
    this.canvasW = this.$refs.content.offsetWidth
    this.canvasH = this.$refs.content.offsetHeight
    
    this.$store.commit("setArrowList", this.arrowList);
    this.$emit("changeArrowShow", false); // 隐藏arrow
    // let type = this.$route.query.type;
    this.type = this.$route.query.type;
    // if (type == "RE") {
      // 回放
      console.log(this.$store.state.projectId)
      this.workId = this.$route.query.workId*1;
      this.oldWorkId = this.$route.query.workId*1
      if(this.workId == ''){
        getWorks({projectId: this.$store.state.projectId}).then((res) => {
          this.workId  = res.data.content.info.list[0].id;
          this.oldWorkId  = res.data.content.info.list[0].id;
        });
      }
      this.$emit("changeArrowShow", true); // 隐藏arrow
      this.REShow = false;
      this.getSetInfo();
      // this.getTimeCheckList(this.workId);
      this.carList = [];
    //   createSocket("ws://" + localStorage.getItem("webSocketUrl") + "/ws");
      
    // } 
    // else {
    //   this.REShow = true;
    //   this.getSetInfo();
    //   console.log(localStorage.getItem("webSocketUrl"))
    //   createSocket("ws://" + localStorage.getItem("webSocketUrl") + "/ws");
    // }
    setTimeout(function(){
      setGrid();
    },100)
    that.iframeWin = that.$refs.iframe.contentWindow
    window.onresize = function temp(e) {
        console.log(e);
        console.log("窗口变动了");

        if(e.currentTarget.innerHeight > 1000){
          that.windowChange = 1
          if(that.iframeShow == true){
            that.iframeWin.postMessage({
              cmd: 'setWindowChange',
              params: 1
            }, '*')
          }
          localStorage.setItem('windowChange',1)
          
        }else{
          that.windowChange = 2
          if(that.iframeShow == true){
            that.iframeWin.postMessage({
              cmd: 'setWindowChange',
              params: 2
            }, '*')
          }
          localStorage.setItem('windowChange',2)
        }
    };

    
    
  },
  methods: {
    outBack(){
      this.reload()
    },
    setCanvasF(e) {
      let that = this;
      console.log(e);
      if (e == 1) {
        // this.midCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        // this.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
      } else if (e == 2) {
        let zoom = 0.1 + this.canvas.getZoom();
        zoom = Math.max(1, zoom); //最小为原来的1/10
        let zoomPoint = new fabric.Point(0, 0);
        this.canvas.zoomToPoint(zoomPoint, zoom);
        event.preventDefault()
        event.stopPropagation()
        that.imgScale = that.imgScale + 0.1
        
        console.log(that.imgScale)
        that.drawImage();   //重新绘制图片
      } else if (e == 3) {
        let zoom = -0.1 + this.canvas.getZoom();
        zoom = Math.max(1, zoom); //最小为原来的1/10
        let zoomPoint = new fabric.Point(0, 0);
        this.canvas.zoomToPoint(zoomPoint, zoom);
        event.preventDefault()
        event.stopPropagation()
        that.imgScale = that.imgScale - 0.1
        
        console.log(that.imgScale)
        that.drawImage();   //重新绘制图片
      } else if (e == 4) {
        if (this.leftOut == true) {
          this.leftOut = false;
          this.leftOutText = "清屏";
          this.$refs.colorContent.style.right = 15 + "px";
        } else {
          this.leftOut = true;
          this.leftOutText = "复屏";
          this.$refs.colorContent.style.right = -400 + "px";
        }
      }
    },
    setTimeToIframe(){
      
      if(this.roadType == 0){
        this.iframeWin.postMessage({
          cmd: 'getFormJson',
          params: this.setRoadMap
        }, '*')
      }else if(this.roadType == 1){
        this.iframeWin.postMessage({
          cmd: 'getFormJsonF',
          params: this.setFRoadMap
        }, '*')
      }
      this.iframeWin.postMessage({
        cmd: 'setRoadType',
        params: {
          roadType: this.roadType
        }
      }, '*')
      this.iframeWin.postMessage({
        cmd: 'setProjectInfo',
        params: {
          projectId: this.search.project,
          workId: this.search.work
        }
      }, '*')
      this.iframeWin.postMessage({
        cmd: 'setWindowChange',
        params: this.windowChange
      }, '*')
      this.iframeWin.postMessage({
        cmd: 'setWorkInfo',
        params: {
          projectName: this.projectName,
          name: this.workName
        }
      }, '*')
      this.iframeWin.postMessage({
        cmd: 'setEquipList',
        params: this.equipmnetList
      }, '*')
    },
    setTime(data) {
      console.log(data)
      // return
      let that = this
      // this.imgX = 0
      // this.imgY = 0
      // this.imgScale = 1
      // this.pos = {}
      // this.posl = {}
      // this.midCanvas.clear()
      this.outBackShow = true
      if(this.roadType == 0){
        // this.contextM.fillStyle = "rgba(0, 0, 0, 0)";
        // this.contextM.fillRect(0, 0, 1920, 1080);
        // this.canvas.clear()
        // console.log(data);
        // clearInterval(this.setInter)
        // this.canvas.clear()
        // this.drawImage()

        this.iframeShow = true
        that.iframeWin = that.$refs.iframe.contentWindow
        console.log(that.iframeWin)
        that.setTimeToIframe()
        that.iframeWin.postMessage({
          cmd: 'setTime',
          params: {
            start: data.startTime,
            end: data.endTime,
            token: Cookies.get("token")
          }
        }, '*')
        
        
      }else{
        this.iframeShow = true
        that.iframeWin = that.$refs.iframe.contentWindow
        console.log(that.iframeWin)
        that.setTimeToIframe()
        that.iframeWin.postMessage({
          cmd: 'setTime',
          params: {
            start: data.startTime,
            end: data.endTime,
            token: Cookies.get("token")
          }
        }, '*')



        // let codeV = 30*60*1000
        // this.value2 = [data.startTime, data.endTime];
        // let startTime = new Date(data.startTime).getTime();
        // let endTime = new Date(data.endTime).getTime();
        // let allTime = endTime - startTime
        // let toStamp = (startTime*1 + codeV) < endTime ?(startTime*1 + codeV):endTime
        // this.startTime = startTime
        // this.endTime = endTime
        // let sTime = timestampToTime(startTime)
        // let toTime = timestampToTime(toStamp)
        // // let endTime = new Date(data.endTime).getTime();
        // console.log(startTime)
        
        // let params = {
        //   workId: this.workId,
        //   startTime: sTime,
        //   endTime: toTime,
        // }
        // this.setMonitorShow = false
        // const loading = this.$loading({
        //     lock: true,
        //     text: 'Loading',
        //     spinner: 'el-icon-loading',
        //     background: 'rgba(0, 0, 0, 0.7)'
        //   });
        // this.cotorl = true
        // getWorkTrack(params).then((res)=>{
        //   console.log(res)
          
        //   console.log(getCode)
        //   that.drawByWork(that.canvas, that.midCanvas,sTime, res);
          
        //   loading.close();

        //   let getMap = this.dataMap
        //   let getMapTime = this.dataMapTime
        //   let getCode = Math.ceil(((toStamp - startTime)/allTime)*100)
        //   that.getpercentNum = getCode
        //   let getWorkTrackFun = function(){
        //         let toStampVal = (toStamp + codeV) >= endTime?endTime:(toStamp + codeV)
        //         let paramsInter = {
        //           workId: that.workId,
        //           startTime: timestampToTime(toStamp),
        //           endTime: timestampToTime(toStampVal),
        //         }
        //         toStamp = toStampVal
                
        //         getWorkTrack(paramsInter).then((r)=>{
        //           console.log(r)
        //           let getCode = Math.ceil(((toStampVal - startTime)/allTime)*100)
        //           that.getpercentNum = getCode

        //           let mapData = r.data.content.dataMap
        //           for(var key in getMap){
        //             getMap[key] = getMap[key].concat(mapData[key])
        //             getMapTime[key] = getMapTime[key].concat(that.getTimeInList(mapData[key]))
                    
        //           }
        //           if(toStamp < endTime){
        //             getWorkTrackFun()
        //           }else{
        //               that.dataMap = getMap
        //             that.dataMapTime = getMapTime
        //           }
        //         })
        //       }
        //   setTimeout(()=>{
        //     getWorkTrackFun()
        //   },2000)
        // })
      }
      
      
      
      
    },
    getTimeInList : function(e){
            let arr = []
            for(let i=0;i<e.length;i++){
                arr.push(new Date(e[i].gpsTime).getTime())
            }
            console.log(arr)
            return arr
        },
    onPercentChange(per) {
      console.log(per);
      this.perCode = per;
    },
    playCodeChange(e) {
      console.log(e);
      clearInterval(this.setInter)
      let setTime = 0
      if(e == 1){
        setTime = 1000
      }else if(e == 2){
        setTime = 500
      }
      this.setInter = setInterval(()=>{
        let time = this.nowTime + 1000
        this.nowTime = time
        if(this.roadType == 0){
          this.playStart(this.nowTime,this.toBigCode,this.canvas)
        }else if(this.roadType == 1){
          this.playStartF(this.nowTime,this.canvas)
        }
        
      },setTime)
    },
    setPlayState() {
      if (this.playStateText == "暂停") {
        console.log('bf')
        this.playStateText = "播放";
        this.setInter = setInterval(()=>{
          let time = this.nowTime + 1000
          this.nowTime = time
          if(this.roadType == 0){
            this.playStart(this.nowTime,this.toBigCode,this.canvas)
          }else if(this.roadType == 1){
            this.playStartF(this.nowTime,this.canvas)
          }
        },1000)
      } else {
        console.log('zt')
        this.playStateText = "暂停";
        clearInterval(this.setInter)
      }
    },
    upSetChange() {
      if(!this.startTime){
        console.log('123')
        this.percentNum = 1
        this.perCode = 1
        return
      }
      let playTime =
        Math.floor(((this.endTime * 1/1000 - this.startTime * 1/1000) * this.perCode) / 100)*1000 + this.startTime;
      clearInterval(this.setInter)
      
      if(this.roadType == 0){
        this.canvas.clear()
        this.initCar(this.canvas,playTime)

        // 绘制历史路径
        this.drawImage()
        this.initHistory(playTime,this.toBigCode)
      }else if(this.roadType == 1){
        this.initCarF(this.canvas,playTime)
        this.initHistoryF(playTime)
      }
      
    },
    getSTime: function (e) {
      console.log(e)
      let time = dateFormat(e, "YYYY-MM-DD")
       console.log(time)
       let params = {}
       if(time){
         params = {
          workId: this.workId,
          startTime: new Date(time + ' 00:00:00').getTime(),
          endTime:new Date(time + ' 23:59:59').getTime()
        };
       }else{
         params = {
          workId: this.workId,
         }
       }
      
      getWorkTimeList(params).then((res) => {
        console.log(res);
        this.timeList = res.data.content.dataList;
      });
      // this.startTime = new Date(
      //   dateFormat(e[0], "YYYY-MM-DD hh:mm:ss")
      // ).getTime();
      // this.endTime = new Date(
      //   dateFormat(e[1], "YYYY-MM-DD hh:mm:ss")
      // ).getTime();
      // this.allTime = this.endTime - this.startTime;
    },
    startRE: function () {
      console.log("RE");
      // let that = this;
      console.log( dateFormat(this.value2, "YYYY-MM-DD"))
      console.log(this.startTimeSet)
      console.log(this.endTimeSet)
      let dayCode = dateFormat(this.value2, "YYYY-MM-DD")
      if(this.value2 == ''){
        this.$message({
          message: "未选中回放日期！",
          type: "warning",
        });
      }else{
        
        let st = this.startTimeSet?this.startTimeSet+':00':'00:00:00'
        let et = this.endTimeSet?this.endTimeSet+':00':'00:00:00'
        let set = {
          startTime: dayCode + ' ' + st,
          endTime: dayCode + ' ' + et,
        }
        this.setTime(set)
      }
      
      
    },
    //切换作业
    workChangeAfter: function(oldD){
      let that = this
      let tokenValue = Cookies.get("token");
      this.carList = [];
      this.percentNum = 0;
      this.playCode = 1;
      let setStr =
          "/GetWorkTrack?token=" +
          tokenValue +
          "&workId=" +
          oldD +
          "&playLevel=" +
          this.playCode +
          "&playState=" +
          0;
        // this.carList = []
        sendWSPush(setStr, function (res) {
          that.drawByWork(that.canvas, that.midCanvas, res);
        });
      this.deleteByREChange();
    },
    deleteByREChange: function () {
      // let that = this;
      let canvasArr = this.canvas.getObjects();
      for (let i = 0; i < canvasArr.length; i++) {
        if (canvasArr[i].id == "group") {
          this.canvas.remove(canvasArr[i]);
        }
        if ((canvasArr[i].id + "").indexOf("groupCarInfo") >= 0) {
          this.canvas.remove(canvasArr[i]);
        }
      }
      // let midCanvasArr = this.midCanvas.getObjects();
      // for (let i = 0; i < midCanvasArr.length; i++) {
      //   if (midCanvasArr[i].id == "carPath") {
      //     that.midCanvas.remove(midCanvasArr[i]);
      //   }
      // }
    },
    warnShow: function () {
      if (this.warnShowCode == 0) {
        this.$refs.warnNumContent.style.right = 360 + "px";
        this.$refs.warnContent.style.right = 0 + "px";
        this.warnShowCode = 1;
      } else {
        this.$refs.warnNumContent.style.right = 0 + "px";
        this.$refs.warnContent.style.right = -360 + "px";
        this.warnShowCode = 0;
      }
    },
    contorFun: function (e, n) {
      //console.log(e)
      this.maskBackCode = e;
      this.maskBackTitle = n;
      this.showCode = true;
      this.hideCode = false;
    },
    maskBack: function () {
      this.showCode = false;
      this.hideCode = true;
    },
    parameterChange: function (e) {
      this.parameterArr = e;
      this.carList = [];
      this.canvas.clear();
      // this.gotosome()
    },
    dimensionChange: function (e) {
      // this.midCanvas.clear();
      this.dimension = e;
      if(this.roadType == 0){
        this.initHistory(this.nowTime,this.toBigCode)
      }else if(this.roadType == 1){
        this.initHistoryF(this.nowTime)
      }
      
    },
    getSetInfo: function () {
      getEnginList({pageSize:100}).then((res) => {
        this.canvas = new fabric.Canvas("dhCanvas", {
          perPixelTargetFind: true,
        });
        this.midCanvas = new fabric.Canvas("midCanvas", {
          perPixelTargetFind: true
        });
        // this.myCanvas = new fabric.Canvas("myCanvas", {
        //   // perPixelTargetFind: true
        // });
        this.projectList = res.data.content.info.list;
        //判断是否从报警履历页面跳转而来
        if(this.$route.query.projectId && this.firstEnter){
          this.search.project=this.$route.query.projectId*1
          this.value2 = this.$route.params.date
          this.startTimeSet = this.$route.params.startTime
          this.endTimeSet = this.$route.params.endTime
          console.log(this.search.project,this.$route.params)
        }else{
          for (let i = 0; i < this.projectList.length; i++) {
            if (this.projectList[i].active == 1) {
              this.search.project = this.projectList[i].id;
            }
          }
        }
        let params = { projectId: this.search.project, pageSize: 1000 };
        this.getSection(params);
      });
    },
    getTimeCheckList: function (e) {
      let params = {
        workId: e,
        // dataType: 1
      };
      getWorkTimeList(params).then((res) => {
        console.log(res);
        this.timeList = res.data.content.dataList;
      });
      getWorkTimeList({workId: e,dataType: 1}).then((res) => {
        // console.log(res);
        let getList = res.data.content.dataList
        let list = []
        for(let i=0;i<getList.length;i++){
          let d = new Date(getList[i]+' 00:00:00')
          list.push(d.getTime())
        }
        // this.pickerOptions = {
        //   disabledDate(time) {
        //     return list.indexOf(time.getTime()) < 0; //
        //   }
        // }
      });
    },
    projectChange: function (e) {
      this.setCanvasF(1)
      this.canvas.clear();
      this.carList=[]
      // closeWs();
      this.search.project = e;
      let params = { projectId: e, pageSize: 100 };
      this.getSection(params);
    },
    workChange: function (e) {
      this.canvas.clear();
      this.carList=[]
      // closeWs();
      let params = {
        id: e,
      };
      //console.log(params)
      this.getWorkInfoFun(params);
      let params1 = {
        workId: e,
      };
      // this.getTimeCheckList(e)
      this.workChangeAfter(this.oldWorkId,e)
      this.oldWorkId = e
      getWorkEquipsList(params1).then((res) => {
        console.log(res,this.progress,'this.progress')
        this.equipmnetList = res.data.content.dataList;
      });
    },
    getSection: function (params) {
      let that = this
      getWorks(params).then((res) => {
        this.workList = res.data.content.info.list;
        if (this.workList.length == 0) {
          this.$message({
            message: "已选工程下暂无作业！请在工程管理新增作业。",
            type: "warning",
          });
          this.search.work = "";
        } else {
          //必须projectId和firstEnter同时满足条件才能将参数赋值
          if(this.$route.query.projectId && this.firstEnter){
            this.search.work = this.workId;
            this.firstEnter = false
          }else{
            this.search.work = this.workList[0].id;
            this.workId = this.workList[0].id
          }
          that.workChangeAfter(that.oldWorkId,this.workId)
          that.oldWorkId = this.workId
          that.getWorkInfoFun({ id: this.search.work });
          let set = {
            workId: this.workId,
          };
          this.getTimeCheckList(this.workId)
          getWorkEquipsList(set).then((res) => {
            this.equipmnetList = res.data.content.dataList;
            this.progress = [];
            this.progress.push({
              name: "总体",
              percentage: 0,
              workTime: "00:00:00",
              remainTime: "00:00:00",
            });
            this.equipmnetList.map((item) => {
              this.progress.push({
                name: item.name,
                percentage: 0,
                workTime: "00:00:00",
                remainTime: "00:00:00",
                code: item.code,
              });
            });
            let setMap = new Map();
            let getData = res.data.content.dataList;
            for (let i = 0; i < getData.length; i++) {
              setMap.set(getData[i].code, getData[i].wheelBackWidth);
            }
            console.log(setMap);

            this.carWidthMap = setMap;
            
            // this.scaleCode = localStorage.getItem('scaleCode')
          });
        }
      });
    },
    getWorkInfoFun: function (params) {
      this.canvas.clear();
      this.carList=[]
      let that = this;
      getWorkInfo(params).then((res) => {
        let sectionId = res.data.content.info.sectionId;
        this.workType = res.data.content.info.workType;
        console.log(this.progress)
        this.projectName = res.data.content.info.projectName
        this.workName = res.data.content.info.name
        if(this.workType == 4 || this.workType == 3){
          this.progressList = [
            {
              name: "总体",
              percentage: "--",
              workTime: "--",
              remainTime: "--",
            },
            {
              name: "摊铺",
              percentage: "--",
              workTime: "--",
              remainTime: "--",
            },
            {
              name: "初压",
              percentage: "--",
              workTime: "--",
              remainTime: "--",
            },
            {
              name: "复压",
              percentage: "--",
              workTime: "--",
              remainTime: "--",
            },
            {
              name: "终压",
              percentage: "--",
              workTime: "--",
              remainTime: "--",
            },
          ]
          
          

        }else{
          this.progressList = this.progress
        }
        let tokenValue = Cookies.get("token");
        let setStr = "";
        if (this.type == "RE") {
          console.log("RE");
        } else {
          that.canvas.clear();
          that.carList=[]
          setStr =
            "/GetWorkStatus?token=" + tokenValue + "&workId=" + params.id;
          sendWSPush(setStr, function (res) {
            console.log(res,'1037')
            if (!res.content && (that.workType == 1 || that.workType == 2)) {
              // console.log("baocuo");
              let totalProgress = 0;
              let totalworkTime = "00:00:00";
              let totalremainTime = "00:00:00";
              // console.log(res, res.progress, that.progress, "baocuo1");
              for (let i = 1; i < that.progress.length; i++) {
                if (that.progress[i].code == res.equipCode) {
                  that.progress[i].percentage =
                    (res.progress * 100).toFixed(0) * 1;
                  that.progress[i].workTime = res.workTime;
                  that.progress[i].remainTime = res.remainTime;
                }
                totalProgress += that.progress[i].percentage;
                if (that.progress[i].workTime > totalworkTime) {
                  totalworkTime = that.progress[i].workTime;
                }
                if (that.progress[i].remainTime > totalremainTime) {
                  totalremainTime = that.progress[i].remainTime;
                }
              }
              that.progress[0].percentage =
                (totalProgress / (that.progress.length - 1)).toFixed(0) * 1;
              that.progress[0].workTime = totalworkTime;
              that.progress[0].remainTime = totalremainTime;
              that.progressList = that.progress
            }
            if(res.topic=='total_work_progress' && (that.workType == 3||that.workType == 4) ){
            that.progressList=[
                {
                name: '总体',
                percentage: (res.workProgress.totalProgress*100).toFixed(0)*1,
                workTime: res.workProgress.totalCostTime,
                remainTime: res.workProgress.totalRemainingTime,
                },{
                  name: '摊铺',
                  percentage: (res.workProgress.pavedProgress*100).toFixed(0)*1,
                  workTime: res.workProgress.pavedCostTime,
                  remainTime: res.workProgress.pavedRemainingTime,
                },{
                  name: '初压',
                  percentage: (res.workProgress.initialStageProgress*100).toFixed(0)*1,
                  workTime: res.workProgress.initialStageCostTime,
                  remainTime: res.workProgress.initialStageRemainingTime,
                },{
                  name: '复压',
                  percentage: (res.workProgress.secondStageProgress*100).toFixed(0)*1,
                  workTime: res.workProgress.secondStageCostTime,
                  remainTime: res.workProgress.secondStageRemainingTime,
                },{
                  name: '终压',
                  percentage: (res.workProgress.thirdStageProgress*100).toFixed(0)*1,
                  workTime: res.workProgress.thirdStageCostTime,
                  remainTime: res.workProgress.thirdStageRemainingTime,
                }]
              }
            that.drawByWork(that.canvas, that.midCanvas, res);
          });
        }
        console.log('123123')
        this.imgX = 0
        this.imgY = 0
        this.imgScale = 1
        this.pos = {}
        this.posl = {}
        // this.midCanvas.clear()
        getRoadSectionPointer({ sectionId: sectionId }).then((r) => {
          this.roadType = r.data.content.dataMap.roadType;
          if(this.roadType == 0){
            let getObj = r.data.content.dataMap
            // let setArr = []
            // let leftArr = []
            // let midArr = []
            // let rightArr = []
            // let getChangeObj = []
            let sale = 15
            this.pyYCode = getObj.middleLine[0].ycord*sale.toFixed(2) + 500
            this.pyXCode = -getObj.middleLine[0].xcord*sale.toFixed(2) + 1000
            // 绘制道路
            if (r.data.content.dataMap == {}) {
              this.$message({
                message: "未绑定道路数据!",
                type: "success",
              });
            } else {
              console.log('setMessage')
              this.setRoadMap = r.data.content.dataMap
              


              // for(let i=0;i<getObj.leftLine.length;i++){
              //   leftArr.push([(getObj.leftLine[i].xcord*sale).toFixed(2)-getObj.middleLine[0].xcord*sale.toFixed(2) + 1000,(getObj.leftLine[i].ycord*sale).toFixed(2)*-1 + getObj.middleLine[0].ycord*sale.toFixed(2) + 500])
              //   midArr.push([getObj.middleLine[i].xcord*sale.toFixed(2)-getObj.middleLine[0].xcord*sale.toFixed(2) + 1000,getObj.middleLine[i].ycord*sale.toFixed(2)*-1 + getObj.middleLine[0].ycord*sale.toFixed(2) + 500 ])
              //   rightArr.push([getObj.rightLine[i].xcord*sale.toFixed(2)-getObj.middleLine[0].xcord*sale.toFixed(2) + 1000,getObj.rightLine[i].ycord*sale.toFixed(2)*-1 + getObj.middleLine[0].ycord*sale.toFixed(2) + 500 ])
              //   setArr.push(getObj.middleLine[i].mileageNum)
              // }
              // getChangeObj = [leftArr,midArr,rightArr,setArr]
              
              // this.initCanvas(this.canvas, this.midCanvas, getChangeObj)
            }
          }else if(this.roadType == 1){
              this.setFRoadMap = r.data.content.dataMap
              let changeObj = changeUnRoadPointer(
                this.canvasW,
                this.canvasH,
                r.data.content.dataMap
              );
              let getChangeObj = changeObj[0];
              this.scaleCode = changeObj[1];
              this.$store.commit("setScaleCode", this.scaleCode);

              // var canvas = new fabric.Canvas("dhCanvas",{
              //     perPixelTargetFind: true
              // });
              this.canvas.selectable = false;
              // //console.log(this.canvas.getObjects())
              // let el = this.canvas.getObjects()
              // this.canvas.remove(el)
              // this.midCanvas.clear();
                this.canvas.clear();
              // canvas.zoomToPoint([zoomPoint], 1);
              this.initCanvas(this.canvas, this.midCanvas, getChangeObj,1);
          }
          
            // this.roadType = res.data.content.dataMap.roadType;
          this.getTimeCheckList(params.id)
        //   }
        });
      });
    },

    tabChange: function (e) {
      this.tabChangeCode = e;
      if (e == 2) {
        this.showCode = false;
        this.hideCode = false;
      }
    },
    goBack: function () {
      this.$router.push({ name: 'QualityDay' });
    },
  },
  components: {
    WorkSet,
    CProgress,
    RollLegend
  },
  sockets: {
    connection() {
      //console.log(data)
    },
    news() {
      //console.log(data)
    },
  },
  destroyed() {
    // this.websock.close()
    // closeWs();
    clearInterval(this.setInter)
  },
  beforeDestroy() {
    // closeWs();
    this.$emit("changeArrowShow", true); // 隐藏arrow
  },
};
</script>

<style lang="scss">
.headerShow{
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 9999;
}
.progressContent {
  .el-input {
    height: 35px;
    width: 70px;
    input {
      height: 35px !important;
      width: 70px !important;
      border-radius: 0;
    }
  }
}
.dlSelectProjectCon{
  .el-input {
      height: 35px;
      width: 120px;
      input {
        height: 35px !important;
        width: 120px !important;
        border-radius: 0;
      }
    }
}
.setMonitorItem {
  width: 100%;
  .projectCon {
    height: 35px;
    width: 240px;
    margin-left: 24px;
    float: left;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-input {
      height: 35px;
      width: 240px;
      input {
        height: 35px !important;
        width: 240px !important;
        border-radius: 0;
      }
    }
    .mileage {
      height: 35px;
      width: 75px;

      input {
        height: 35px !important;
        width: 75px !important;
      }
    }
    .mileage_1 {
      margin: 0 9px;
    }
    .mileage_2 {
      margin-left: 10px;
    }
    .el-date-editor {
      // height: ;
    }
  }
  .projectConDD{
    height: 35px;
    width: 260px;
    margin-left:2px;
    float: left;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-date-editor {
      height: 35px;
      width: 115px;
      margin-left: 10px;
    }
    .el-range-separator {
      font-size: 12px;
      width: 22px;
      line-height: 28px;
      padding: 0 2px;
    }
    .el-range-input {
      width: 130px;
    }
    .el-input__prefix{
      height: 31px;
      width: 31px;
    }
    .el-input__icon {
      height: 31px;
      width: 31px;
      display: block;
    }
  }
  .projectConD {
    height: 35px;
    width: 240px;
    margin-left: 24px;
    float: left;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-date-editor {
      height: 35px;
      width: 240px;
    }
    .el-range-separator {
      font-size: 12px;
      width: 22px;
      line-height: 28px;
      padding: 0 2px;
    }
    .el-range-input {
      width: 130px;
    }
    .el-input__prefix{
      height: 31px;
      width: 31px;
    }
    .el-input__icon {
      height: 31px;
      width: 31px;
      display: block;
    }
  }
  .workCon {
    height: 35px;
    width: 240px;
    margin-left: 11px;
    float: left;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-input {
      height: 35px;
      width: 240px;
      input {
        height: 35px !important;
        width: 240px !important;
        border-radius: 0;
      }
    }
  }
  .setMonitorItem{
    .el-input{
      .el-input__inner{
        font-size: 12px !important;
      }
    }
    
  }
}
@keyframes leftToShow {
  from {
    left: -400px;
  }
  to {
    left: 0px;
  }
}
@keyframes leftToHide {
  from {
    left: 0px;
  }
  to {
    left: -400px;
  }
}
.infoListShow {
  width: 370px;
  margin: 0 auto;
  margin-top: 14px;
  // position: relative;
  .infoItemSetMask {
    height: 577px;
    width: 400px;
    position: absolute;
    bottom: 0;
    left: -400px;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 100;
    .setMaskTitle {
      height: 30px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      line-height: 30px;
      font-size: 14px;
      text-align: left;
      padding-left: 20px;
      background-color: #e96b5a;
      color: #ffffff;
    }
    .workSet {
      height: 547px;
      width: 100%;
      position: absolute;
      top: 30px;
      left: 0;
      background-color: rgba(255, 255, 255, 1);
    }
    .setMaskContent {
      height: 547px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .maskBack {
      height: 30px;
      width: 30px;
      line-height: 30px;
      position: absolute;
      top: 0;
      right: 0;
      color: #ffffff;
      font-size: 16px;
      z-index: 10;
      text-align: center;
      cursor: pointer;
    }
  }
  .leftToShowClass {
    animation: leftToShow 0.5s infinite;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
  }
  .leftToHideClass {
    animation: leftToHide 1s infinite;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
  }
  .contorl_1 {
    display: inline-block;
    font-size: 12px;
    line-height: 13px;
    padding: 7px 8px;
    color: #ffffff;
    background-color: #e96b5a;
    border-radius: 2px;
  }
  .contorl_2 {
    display: inline-block;
    font-size: 12px;
    line-height: 13px;
    padding: 7px 8px;
    color: #e24747;
    background: rgba(252, 232, 232, 1);
    border: 1px solid rgba(251, 158, 158, 1);
    border-radius: 2px;
    margin-left: 6px;
  }
  .el-table__header-wrapper {
    height: 30px;
    border: 1px solid rgba(228, 231, 237, 1);
    .el-table__header {
      height: 30px !important;
      tr {
        th {
          background-color: #f5f5f5 !important;
          color: #888888 !important;
          font-size: 12px !important;
          padding: 0 !important;
          height: 30px !important;
          font-weight: 100 !important;
        }
      }
    }
  }
  .el-table__body-wrapper {
    height: 530px;
    overflow-y: auto !important;
    overflow-x: hidden;
    tr {
      td {
        padding: 20px 0 !important;
        color: #555555 !important;
        font-size: 14px !important;
      }
    }
  }
}
.workProgress_content {
  .el-progress__text {
    color: #222222 !important;
  }
}
.canvas-container {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
}
</style>

<style lang="scss" scoped="">
.dlSelect{
  position: fixed;
  top: 128px;
  right: 240px;
  z-index: 1000;
}
.dlSelectProjectCon{
  position: fixed;
  top: 122px;
  right: 120px;
  z-index: 1000;
}
.outBack{
  height: 35px;
  width: 80px;
  background-color: #ffffff;
  position: fixed;
  top: 66px;
  right: 18px;
  line-height: 35px;
  text-align: center;
  border-radius: 5px;
  font-size: 14px;
  z-index: 1000;
  cursor: pointer;
}
.contorlContent {
  height: 40px;
  width: 420px;
  background-color: #ffffff;
  position: fixed;
  top: 62px;
  right: 18px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  opacity: 1;
  z-index: 999;
  display: flex;
  cursor: pointer;
  .itemContorl {
    flex: 1;
    position: relative;
    .line {
      width: 1px;
      height: 15px;
      background: #eaeaea;
      position: absolute;
      top: 12px;
      right: 0;
    }
    .type {
      height: 18px;
      width: 18px;
      position: absolute;
      top: 11px;
      left: 19px;
    }
    .type_1 {
      background-image: url("../../images/icon/type_1.png");
      background-size: 100% 100%;
    }
    .type_2 {
      background-image: url("../../images/icon/type_2.png");
      background-size: 100% 100%;
    }
    .type_3 {
      background-image: url("../../images/icon/type_3.png");
      background-size: 100% 100%;
    }
    .type_4 {
      background-image: url("../../images/icon/type_4.png");
      background-size: 100% 100%;
    }
    .text {
      height: 12px;
      line-height: 12px;
      display: inline-block;
      position: absolute;
      top: 14px;
      color: #555555;
      left: 47px;
      font-size: 12px;
    }
  }
}
.progressContent {
  height: 90px;
  width: 100%;
  position: fixed;
  background: #ffffff;
  left: 0;
  bottom: 0;
  padding: 24px;
  z-index: 999;
  .progressContentBG{

  }
  .playAndPuase_1 {
    height: 20px;
    width: 20px;
    background-image: url("../../images/icon/play.png");
    background-size: 100% 100%;
    position: absolute;
    top: 50px;
    left: 24px;
    cursor: pointer;
  }
  .playAndPuase_2 {
    height: 20px;
    width: 20px;
    background-image: url("../../images/icon/puase.png");
    background-size: 100% 100%;
    position: absolute;
    top: 50px;
    left: 24px;
    cursor: pointer;
  }
  .nowDateTimeShow {
    height: 20px;
    line-height: 20px;
    position: absolute;
    color: #777777;
    font-size: 14px;
    top: 50px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .playState {
    height: 20px;
    line-height: 20px;
    position: absolute;
    top: 50px;
    color: #777777;
    font-size: 14px;
    left: 24px;
    cursor: pointer;
  }
  .speedText {
    height: 20px;
    line-height: 20px;
    position: absolute;
    top: 50px;
    color: #777777;
    font-size: 14px;
    left: 60px;
    cursor: pointer;
  }
  .playCodeChange {
    position: absolute;
    top: 43px;
    left: 130px;
  }
}
.content {
  height: 1015px;
  width: 1920px;
  position: relative;
  .setCarInfo {
    height: 70px;
    width: 150px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #e1e1e1;
    border: 1px #e1e1e1 solid;
    border-radius: 5px;
    .setCarTitle {
      height: 30px;
      width: 100%;
      position: absolute;
      line-height: 30px;
      font-size: 12px;
      text-align: center;
      color: #282828;
      top: 0;
      left: 0;
    }
    .setCarBtnL {
      height: 30px;
      width: 60px;
      line-height: 30px;
      font-size: 12px;
      position: absolute;
      bottom: 5px;
      left: 10px;
      color: #ffffff;
      background-color: rgba(233, 107, 90, 1);
      border-radius: 3px;
      text-align: center;
      cursor: pointer;
    }
    .setCarBtnR {
      height: 30px;
      width: 60px;
      line-height: 30px;
      font-size: 12px;
      position: absolute;
      bottom: 5px;
      right: 10px;
      color: #282828;
      background-color: rgba(233, 107, 90, 0.3);
      border-radius: 3px;
      text-align: center;
      cursor: pointer;
    }
  }
  .toPlay {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: aqua;
    color: black;
    font-size: 20px;
    width: 60px;
    position: absolute;
    top: 50px;
    right: 50px;
    cursor: pointer;
  }
  .topOut{
    // z-index: 1000  !important
  }
  #myCanvas {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
  }
  #midCanvas {
    position: absolute !important;
    top: 0 ;
    left: 0 ;
  }
  #dhCanvas {
    position: absolute !important;
    top: 0 ;
    left: 0 ;
  }
  .warnContent {
    min-height: 300px;
    max-height: 500px;

    overflow: hidden;
    overflow-y: scroll;
    width: 360px;
    position: fixed;
    right: -360px;
    top: 30%;
    background-color: #ffffff;
    z-index: 100;
    .itemTop {
      height: 28px;
      width: 100%;
      margin-top: 8px;
      .itemType {
        height: 28px;
        line-height: 26px;
        padding: 0 8px;
        background: #fce8e8;
        border: 1px solid #fb9e9e;
        border-radius: 2px;
        float: left;
        margin-left: 16px;
        color: #e24747;
        font-size: 12px;
      }
      .itemEquipName {
        height: 28px;
        line-height: 28px;
        color: #282828;
        font-size: 14px;
        float: left;
        margin-left: 8px;
        font-weight: bold;
      }
      .setStop {
        height: 28px;
        line-height: 26px;
        padding: 0 8px;
        background: #fce8e8;
        border: 1px solid #fb9e9e;
        border-radius: 2px;
        float: right;
        margin-right: 10px;
        color: #e24747;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .itemTitle {
      height: 30px;
      width: 100%;
      position: relative;
      .bgLine {
        display: inline-block;
        height: 14px;
        width: 4px;
        position: absolute;
        left: 21px;
        top: 15px;
        background: #e96b5a;
      }
      .itemTitleText {
        display: inline-block;
        height: 15px;
        line-height: 15px;
        position: absolute;
        top: 15px;
        left: 30px;
        color: #282828;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .itemContent {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;

      .itemShow {
        // width: 50%;
        height: 28px;
        line-height: 14px;
        font-size: 14px;
        padding: 7px 20px 7px 26px;
        color: #e24747;
        position: relative;
        margin-top: 12px;
        margin-left: 11px;
        background: #ffe8e8;
        .redPointer {
          display: inline-block;
          height: 8px;
          width: 8px;
          border-radius: 50%;
          background-color: red;
          position: absolute;
          top: 10px;
          left: 10px;
        }
      }
    }
  }
  .warnNumContent {
    height: 90px;
    width: 36px;
    background: #e96b5a;
    position: fixed;
    top: 32%;
    right: 0;
    cursor: pointer;
    .warnNum {
      width: 20px;
      height: 20px;
      background: #ffffff;
      position: absolute;
      border-radius: 50%;
      top: 12px;
      left: 50%;
      transform: translateX(-50%);
      line-height: 20px;
      text-align: center;
      color: #e24747;
      font-size: 16px;
    }
    .warnText {
      width: 15px;
      height: auto;
      position: absolute;
      top: 42px;
      left: 50%;
      transform: translateX(-50%);
      color: #ffffff;
      font-size: 14px;
      word-wrap: normal;
    }
  }
  .leftOut {
    left: -500px !important;
  }
  .setMonitor {
    height: auto;
    width: 600px;
    position: fixed;
    background-color: #ffffff;
    // top: 126px;
    // left: 15px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    padding-top: 16px;
    padding-bottom: 16px;
    z-index: 800;
    .title_1 {
      height: 16px;
      width: 100%;
      position: relative;
      margin-bottom: 17px;
      .iconShow {
        width: 4px;
        height: 16px;
        background: rgba(233, 107, 90, 1);
        position: absolute;
        top: 0;
        left: 16px;
      }
      .titleText {
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        font-weight: bold;
        color: #222222;
        position: absolute;
        top: 0;
        left: 28px;
      }
    }
    .timeCheckItem {
      width: 100%;
      height: auto;
      margin-top: 13px;
      padding-left: 24px;
      .timeCheck {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #777777;
        cursor: pointer;
      }
    }

    .setMonitorItem {
      width: 100%;
      height: 75px;
      margin-top: 13px;
      position: relative;
      // background-color: aqua;

      .itemText {
        height: 35px;
        line-height: 35px;
        width: 100%;
        padding-left: 24px;
        color: #777777;
        font-size: 14px;
        float: left;
      }
      .nowDateTimeShow {
        height: 20px;
        line-height: 20px;
        position: absolute;
        color: #777777;
        font-size: 14px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .infoListContent {
    width: 400px;
    height: 622px;
    position: fixed;
    top: 288px;
    left: 15px;
    background-color: #ffffff;
    overflow: hidden;
    .infoTab {
      height: 45px;
      width: 100%;
      display: flex;
      .tabItem {
        flex: 1;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        color: #555555;
        cursor: pointer;
        background-color: #f5f7fa;
      }
      .tabItem_r,
      .tabItem_w {
        background-color: #ffffff;
        // border-right: 1px solid rgba(228, 231, 237, 1);
        // border-bottom: 1px solid rgba(228, 231, 237, 1);
        color: #e24747 !important;
        font-weight: bold;
      }
      .tabItem_l {
        background-color: #ffffff;
        // border-left: 1px solid rgba(228, 231, 237, 1);
        // border-bottom: 1px solid rgba(228, 231, 237, 1);
        color: #e24747 !important;
        font-weight: bold;
      }
    }
  }
  .contorClick {
    display: inline-block;
    padding: 5px 15px;
    background: rgba(233, 107, 90, 0.35);
    color: rgba(233, 107, 90, 1);
    cursor: pointer;
  }
  .wordStatus_1 {
    display: inline-block;
    padding: 4px 9px;
    background: rgba(242, 242, 245, 1);
    color: #999999;
  }
  .wordStatus_2 {
    display: inline-block;
    padding: 4px 9px;
    background: rgba(225, 235, 250, 1);
    color: #2273f8;
  }
  .wordStatus_3 {
    display: inline-block;
    padding: 4px 9px;
    background: rgba(221, 240, 229, 1);
    color: #10c766;
  }
  .colorContent {
    height: 150px;
    width: 300px;
    position: fixed;
    right: 15px;
    bottom: 110px;
    background-color: #ffffff;
    .rollImg {
      width: 290px;
      height: 90px;
      position: absolute;
      background-image: url("../../images/all/rollNum.png");
      background-size: 100% 100%;
      bottom: 10px;
      left: 0px;
      background-size: 100% 100%;
    }
    .icvImg {
      width: 290px;
      height: 90px;
      position: absolute;
      background-image: url("../../images/all/icvNum.png");
      background-size: 100% 100%;
      bottom: 10px;
      left: 0px;
      background-size: 100% 100%;
    }
    .colorType {
      height: 28px;
      width: 148px;
      position: absolute;
      display: flex;
      left: 50%;
      transform: translateX(-50%);
      top: 13px;
      .colorItem {
        flex: 1;
        line-height: 28px;
        color: #888888;
        font-size: 12px;
        text-align: center;
      }
      .colorItem_1 {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid rgba(228, 231, 237, 1);
      }
      .colorItem_2 {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid rgba(228, 231, 237, 1);
      }
      .colorActive {
        border: none;
        color: #ffffff !important;
        background-color: #e96b5a;
      }
    }
  }
}
.workProgress {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  color: #222222;
  .workProgress_title {
    font-size: 16px;
    font-weight: bold;
  }
  .workProgress_content {
    height: 55px !important;
    margin-top: 12px;
    margin-left: 18px;
    font-size: 14px;
    line-height: 24px;
    height: 24px;
    border-bottom: 1px solid #e1e1e1;
  }
}
.rollLegend{
  transform: scale(0.8);
  position: relative;
  right: 30px;
  top: 35px;
}

#show-iframe{
  position: fixed;
  height: 960px;
  width: 1920px;
  top: 112px;
  left: 0;
  // transform: translate(-50%,-50%);
  z-index: 900;
  background-color: white;
}
.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  z-index: 1000;
}
</style>